// extracted by mini-css-extract-plugin
module.exports = {"root":"NoShows_root__1WBeq"};